import { NavigationGuardNext, Route } from 'vue-router';

export function allowedRoutesGuard(allowedRoutes: string[], fallbackRoute: string) {
  return (to: Route, from: Route, next: NavigationGuardNext) => {
    const canEnter = allowedRoutes.includes(from.name as string);

    if (canEnter) next();
    else next({ name: fallbackRoute });
  };
}
